// extracted by mini-css-extract-plugin
export default {"default":"LayoutAppDark__default___VQhOO"};